import React from 'react'
import { observer, inject } from 'mobx-react'
import { Progress } from 'react-sweet-progress'
import 'react-sweet-progress/lib/style.css'

import anchorScroll from '../../../utils/anchorScroll'

const ProfileButton = ({ userStore, translationStore, dropdownStore, guidedIntroductionStore }) => {
  const printName = userStore.currentUser ? userStore.currentUser.crm_customer.firstname : ''

  const onProfileClick = () => {
    dropdownStore.closeDropdown()
    anchorScroll('top', '/profile')
  }

  const onIntroductionClass = () =>  guidedIntroductionStore.showIntroduction && 'z-m1'

  return (
    <span className='nav-perfil__perfil' onClick={onProfileClick}>
      <div className='nav-perfil__perfil__inner'>
        <div className={`nav-perfil__perfil__inner__left ${onIntroductionClass()}`}>
          <div
            className='absolute mx-profilex'
            style={{
              top: '5px',
              bottom: '-2px',
              left: 0,
              right: 0,
              backgroundRepeat: 'no-repeat',
              backgroundImage: 'Url(/img/user_profile.svg)',
            }}
          />
          <Progress
            style={{
              fontSize: 0,
            }}
            type='circle'
            width={45}
            percent={userStore.calculateCompletion()}
            theme={{
              default: {
                trailColor: '#dbc987',
                color: '#dbc987',
                symbol: ' '
              },
              active: {
                trailColor: '#dadada',
                color: '#dbc987',
                symbol: ' '
              },
              success: {
                trailColor: '#dadada',
                color: '#dbc987',
                symbol: ' '
              }
            }}/>
        </div>
        <div className='nav-perfil__perfil__inner__right'>
          <p className='name'>
            {printName}
          </p>
          <p className={'details'}> {`${translationStore.translate('header_profile_at').toUpperCase()} ${userStore.calculateCompletion()}%`}</p>
        </div>
      </div>
    </span>
  )
}

export default inject('translationStore', 'userStore', 'dropdownStore', 'guidedIntroductionStore')(observer(ProfileButton))



// WEBPACK FOOTER //
// ./src/components/Header/LoggedInHeader/ProfileButton.js